export default (state) => ({
  csgEnvironment: state.csgEnvironment,
  meta: {
    uuid: state.meta.uuid,
    city: state.meta.city,
    town: state.meta.town,
    line1: state.meta.line1,
    line2: state.meta.line2,
    country: state.meta.country,
    firstName: state.meta.firstName,
    postalCode: state.meta.postalCode,
    locationId: state.meta.locationId,
    marketType: state.meta.marketType,
    emailAddress: state.meta.emailAddress,
    customerState: state.meta.customerState,
    conversationId: state.meta.conversationId,
    stateOrProvince: state.meta.stateOrProvince,
    businessPromotion: state.meta.businessPromotion,
    billerMappingCode: state.meta.billerMappingCode,
    isCurrentCustomer: state.meta.isCurrentCustomer,
  },
})